import React, {useState} from 'react';
import {classes} from './Summary.st.css';
import {FoldableSummarySection} from '../../../common/components/FoldableSummarySection/FoldableSummarySection';
import {PaymentRequestItemSection} from './PaymentRequestItemSection/PaymentRequestItemSection';
import {PaymentRequestTotals} from './PaymentRequestTotals/PaymentRequestTotals';
import {useControllerProps} from '../Widget/ControllerContext';
import {summaryMobileViewState} from '../constants';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';

export interface PaymentRequestMobileSummaryProps {
  total: string;
}

export const PaymentRequestMobileSummary = ({total}: PaymentRequestMobileSummaryProps) => {
  const {
    paymentRequestStore: {sendClickOnSummaryMobileViewSectionBIEvent},
  } = useControllerProps();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  const [isFoldableSummarySectionOpen, setIsFoldableSummarySectionOpen] = useState(false);

  const toggleFoldableSummarySection = () => {
    const isSummaryOpen = !isFoldableSummarySectionOpen;
    setIsFoldableSummarySectionOpen(isSummaryOpen);
    sendClickOnSummaryMobileViewSectionBIEvent(
      isSummaryOpen ? summaryMobileViewState.SHOW : summaryMobileViewState.HIDE
    );
  };

  return (
    <>
      <FoldableSummarySection
        onClick={toggleFoldableSummarySection}
        isOpen={isFoldableSummarySectionOpen}
        shouldShowErrorIcon={false}
        total={total}
      />
      {isFoldableSummarySectionOpen && (
        <div
          className={
            checkoutUIRevampOrderSummary
              ? classes.topSummaryWithFoldableSection
              : /* istanbul ignore next */
                classes.topSummaryWithFoldableSectionOld
          }>
          <PaymentRequestItemSection />
          <PaymentRequestTotals total={total} />
        </div>
      )}
    </>
  );
};
